// TODO: Add correct types and move it to /types folder
export type User = {
  id: string;
  authId: string;
  name: string;
  email: string;
  acceptedInvite: boolean;
  role: UserRole;
  notificationTokensWeb?: NotificationTokensWeb[];
  createdAt: Date;
  updatedAt?: Date;
  deletedAt: Date | null;
};

export type UserFormData = User & {
  password?: string;
};

export enum UserRole {
  Admin = 'admin',
  User = 'user',
}

export enum InviteStatus {
  Pending = 'PENDING',
  Accepted = 'ACCEPTED',
}

export type NotificationTokensWeb = {
  token: string;
  userAgent: string;
  createdAt: string;
  deactivatedAt?: string;
  successCount: number;
  failCount: number;
  lastSuccessAt?: string;
  lastFailAt?: string;
};
